import { useGlobalState } from "../../GlobalState";

/**
 * Score
 */
export function ScoreInterface(){
    const { score } = useGlobalState();

    return (<h1>{score} Bincas</h1>)

}